import React from 'react';
import clsx from 'clsx';
import styles from './Link.module.scss';

const Link = ({
  href,
  children,
  variant = 'default',
  size = 'md',
  external = false,
  disabled = false,
  className,
  ...props
}) => {
  const externalProps = external ? {
    target: '_blank',
    rel: 'noopener noreferrer',
  } : {};

  const linkClassName = clsx(
    styles.Link,
    styles[`Link--${variant}`],
    {
      [styles['Link--disabled']]: disabled,
    },
    className
  );

  if (disabled) {
    return (
      <span
        className={linkClassName}
        data-size={size}
        aria-disabled="true"
        {...props}
      >
        {children}
      </span>
    );
  }

  return (
    <a
      href={href}
      className={linkClassName}
      data-size={size}
      {...externalProps}
      {...props}
    >
      {children}
    </a>
  );
};

export default Link;
